import convertToAppropriateUnit from "@/lib/ingredients/convertToAppropriateUnit";
import normalizeRecipeIngredients from "@/lib/ingredients/normalizeRecipeIngredients";
import tidyQuantityIntoFractions from "@/lib/ingredients/tidyQuantityIntoFractions";

const useIngredients = (recipe = null) => {
  let ingredients = normalizeRecipeIngredients(
    recipe.recipeIngredients,
    recipe.servingSize
  );

  let ingredientsVolumeToMass = normalizeRecipeIngredients(
    recipe.recipeIngredients,
    recipe.servingSize,
    true
  );

  return {
    tidyQuantityIntoFractions,
    convertToAppropriateUnit,
    ingredients,
    ingredientsVolumeToMass,
  };
};

export default useIngredients;
